module.exports = __webpack_public_path__ + "baike-again.png?282a74d8d41fa69fc4e0fc94b822cf38";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/release/baike-again.png
// module id = 281
// module chunks = 2 4